var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.6%",
    y: "-3.9%",
    width: "107.1%",
    height: "107.9%",
    filterUnits: "objectBoundingBox",
    id: "pxxuikf8ma"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.992 6.394A6.423 6.423 0 0 0 16.078 2.5 6.444 6.444 0 0 0 12 3.95 6.444 6.444 0 0 0 7.924 2.5c-.862 0-1.698.167-2.488.498A6.409 6.409 0 0 0 2.01 6.394a6.349 6.349 0 0 0-.51 2.501c0 .818.165 1.67.493 2.536.275.725.669 1.476 1.172 2.234.797 1.2 1.894 2.453 3.255 3.722 2.256 2.104 4.49 3.558 4.585 3.616l.576.374a.774.774 0 0 0 .838 0l.576-.374a36.896 36.896 0 0 0 4.585-3.616c1.361-1.269 2.458-2.521 3.255-3.722.503-.758.9-1.51 1.171-2.234.329-.866.494-1.718.494-2.536a6.305 6.305 0 0 0-.508-2.501zm-9.99 13.04s-8.655-5.6-8.655-10.539c0-2.501 2.05-4.53 4.578-4.53A4.584 4.584 0 0 1 12 6.832a4.584 4.584 0 0 1 4.077-2.465c2.528 0 4.577 2.028 4.577 4.53 0 4.939-8.654 10.539-8.654 10.539z",
    id: "6tr4wvulib"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#pxxuikf8ma)",
    xlinkHref: "#6tr4wvulib"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#6tr4wvulib"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLove);
export default __webpack_public_path__ + "static/media/ic_love.f7b433acd70d7eb432bfed9d3568c1ca.svg";
export { ForwardRef as ReactComponent };